import React from 'react';

const Privacy = () => {
	return (
		<div className="bg-ofg-light-green">
			<div className="container mx-auto leading-6 px-7 py-28 font-redhat text-ofg-light-tan">
				<h1 className="mb-10 text-6xl font-light">
					One Fang Gang <br />
					<span className="font-extrabold">Cookie Policy</span>
				</h1>
				<p className="w-full mb-5 lg:max-w-1/2">Last Updated: 7th Feb 2024</p>
				<p className="w-full mb-5 lg:max-w-1/2">
					Welcome to One Fang Gang! This Cookie Policy explains how we use
					cookies and similar tracking technologies on our website. By using our
					website, you consent to the use of cookies as described in this
					policy.
				</p>
				<h3 className="mb-5 text-3xl font-bold">1. What Are Cookies?</h3>
				<p className="w-full mb-5 lg:max-w-1/2">
					Cookies are small text files stored on your device (computer,
					smartphone, tablet) when you visit a website. They serve various
					purposes such as improving website functionality, analyzing website
					usage, and personalizing your experience.
				</p>
				<h3 className="mb-5 text-3xl font-bold">2. Types of Cookies We Use</h3>
				<h4 className="mb-4 text-xl">2.1 Essential Cookies</h4>
				<p className="w-full mb-5 lg:max-w-1/2">
					These cookies are necessary for the operation of our website and
					enable core functionalities such as security, network management, and
					accessibility. You cannot opt-out of essential cookies as they are
					crucial for the proper functioning of the website.
				</p>
				<h4 className="mb-4 text-xl">2.2 Performance Cookies</h4>
				<p className="w-full mb-5 lg:max-w-1/2">
					We use performance cookies to collect information about how visitors
					use our website, such as which pages are visited most frequently and
					if any error messages are encountered. This helps us improve the
					performance of our website and enhance your user experience.
				</p>
				<h4 className="mb-4 text-xl">2.3 Functionality Cookies</h4>
				<p className="w-full mb-5 lg:max-w-1/2">
					Functionality cookies allow our website to remember choices you make
					(such as language preferences) and provide enhanced features. These
					cookies enable us to personalize your experience and make it more
					convenient.
				</p>
				<h4 className="mb-4 text-xl">2.4 Advertising Cookies</h4>
				<p className="w-full mb-5 lg:max-w-1/2">
					We may use advertising cookies to deliver personalized advertisements
					to you based on your interests and browsing behavior. These cookies
					may track your online activities across different websites and tailor
					advertisements accordingly.
				</p>
				<h3 className="mb-5 text-3xl font-bold">3. Third-Party Cookies</h3>
				<p className="w-full mb-5 lg:max-w-1/2">
					Some cookies on our website may be placed by third-party service
					providers, such as analytics providers or advertising networks. These
					third parties may use cookies to collect information about your online
					activities and provide targeted advertisements.
				</p>
				<h3 className="mb-5 text-3xl font-bold">4. Cookie Consent</h3>
				<p className="w-full mb-5 lg:max-w-1/2">
					When you visit our website for the first time, we will request your
					consent to use non-essential cookies. You can manage your cookie
					preferences through our cookie banner or browser settings. Please note
					that disabling certain cookies may impact the functionality of our
					website.
				</p>
				<h3 className="mb-5 text-3xl font-bold">5. How to Control Cookies</h3>
				<p className="w-full mb-5 lg:max-w-1/2">
					You can control and/or delete cookies as you wish. You can delete all
					cookies that are already on your device and you can set most browsers
					to prevent them from being placed. If you do this, however, you may
					have to manually adjust some preferences every time you visit a site
					and some services and functionalities may not work.
				</p>
				<h3 className="mb-5 text-3xl font-bold">
					6. Changes to This Cookie Policy
				</h3>
				<p className="w-full mb-5 lg:max-w-1/2">
					We may update this Cookie Policy from time to time to reflect changes
					in our practices or for other operational, legal, or regulatory
					reasons. We will notify you of any changes by posting the updated
					policy on our website with the effective date.
				</p>
				<h3 className="mb-5 text-3xl font-bold">7. Contact Us</h3>
				<p className="w-full mb-5 lg:max-w-1/2">
					If you have any questions or concerns about our use of cookies or this
					Cookie Policy, please contact us at
					<a href="mailto:contact@onefanggang.com" target="_new">
						contact@onefanggang.com
					</a>
					.
				</p>
				<p className="w-full lg:max-w-1/2">
					Thank you for visiting One Fang Gang!
				</p>
			</div>
		</div>
	);
};

export default Privacy;
